import React, { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import { setUserUIScreen } from '../../../../store/ui/ui.actions'
import { USER_SCREENS } from '../../../../store/ui/ui.constants'
import { selectFavoritePlaceholder, selectUserUIScreenParams } from '../../../../store/ui/ui.selectors'
import { addOrEditHomeOrWorkFavorite, addOtherFavorite } from '../../../../store/userAccount/userAccount.actions'
import { selectUserFavorites } from '../../../../store/userAccount/userAccount.selectors'
import { pick } from '../../../../utils/object'
import { equalsIgnoreCase, removeHtmlEmSpanAndITags } from '../../../../utils/string'
import arrowLeft from '../../../genericComponents/assets/arrow-left.svg'
import { useTemporaryVisible } from '../../../genericComponents/useTemporaryVisible'
import SuggestContent from '../../../suggest/SuggestContent'
import SVGIcon from '../../../svg/SVGIcon'
import { useAction } from '../../../utils/react-redux'
import { FAVORITE_TYPES } from '../../UserAccount.constants'
import FavoriteInput from './FavoriteInput'
import s from './UserManageFavorite.less'

const UserManageFavorite = () => {
  const execSetUserUIScreen = useAction(setUserUIScreen)
  const navigateBack = () => execSetUserUIScreen(USER_SCREENS.favorites)
  const { type } = useSelector(selectUserUIScreenParams)
  const favorites = useSelector(selectUserFavorites)
  const saveOther = useAction(addOtherFavorite)
  const saveHomeOrWork = useAction(addOrEditHomeOrWorkFavorite)
  const initialValue = favorites?.[type]?.address ?? ''
  const [value, setValue] = useState(initialValue)
  const [visible, setVisible] = useTemporaryVisible()
  const [favoriteError, setFavoriteError] = useState()

  const placeholder = useSelector(selectFavoritePlaceholder)

  const onSuggestClicked = useCallback(
    async suggestion => {
      const isPoi = suggestion.type === 'poi'
      const address = removeHtmlEmSpanAndITags(isPoi ? suggestion.labels[1] : suggestion.labels.join(' '))

      if (equalsIgnoreCase(type, FAVORITE_TYPES.OTHER)) {
        const favorite = {
          ...(isPoi ? { label: removeHtmlEmSpanAndITags(suggestion.labels[0]) } : {}),
          address,
          type
        }

        const saveOtherResult = await saveOther(favorite)

        if (saveOtherResult?.error) {
          setVisible(true)
          setFavoriteError(saveOtherResult.error)

          return
        }
      } else {
        const favorite = {
          ...pick(favorites?.[type] ?? {}, ['uuid', 'showHome']),
          address,
          type
        }

        const saveHomeOrWorkResult = await saveHomeOrWork(favorite)

        if (saveHomeOrWorkResult?.error) {
          setVisible(true)
          setFavoriteError(saveHomeOrWorkResult.error)

          return
        }
      }
      navigateBack()
    },
    [setVisible, setFavoriteError, saveHomeOrWork]
  )

  const onChange = ({ value: val }) => {
    setValue(val)
  }

  return (
    <div className={s.root}>
      {visible && <div className={s.errorMessage}>{favoriteError}</div>}
      <div className={s.search}>
        <div className={s.back} onClick={navigateBack}>
          <SVGIcon url={arrowLeft} />
        </div>
        <form className={s.form} onSubmit={e => e.preventDefault()}>
          <FavoriteInput placeholder={placeholder} value={value} onChange={onChange} />
        </form>
      </div>
      <div className={s.suggest}>
        <SuggestContent onClick={onSuggestClicked} withoutFavorites />
      </div>
    </div>
  )
}

export default UserManageFavorite
